import kamala from '../../kamala'
import Loading from './Loading.js'

Loading.install = function (Vue) {
  kamala(Vue)

  Vue.component(Loading.name, Loading)
}

export default Loading
